export enum EventCodes {
	creditLimitChange = 'CREDIT_LIMIT_CHANGE',
	creditLimitChangeFail = 'CREDIT_LIMIT_CHANGE_FAIL',
	mobileAdd = 'MOBILE_ADD',
	spoProductDeactivate = 'SPO_PRODUCT_DEACTIVATE',
	spoProductActivate = 'SPO_PRODUCT_ACTIVATE',
	spoProductActivateFail = 'SPO_PRODUCT_ACTIVATE_FAIL',
	spoProductChange = 'SPO_PRODUCT_CHANGE',
	subscriptionCancellation = 'SUBSCRIPTION_CANCELLATION',
	subscriptionOrder = 'SUNSCRIPTION_ORDER',
	loyaltyGroupCreation = 'LOYALTY_GROUP_CREATION',
	loyaltyGroupUpdate = 'LOYALTY_GROUP_UPDATE',
	loyaltyGroupDelete = 'LOYALTY_GROUP_DELETE',
}

export enum PaymentMethods {
	M = 'Monthly bill',
	C = 'Credit card',
}
